<script lang="ts" setup>
  import Button from "@/components/ui/button/Button.vue"
  import { DialogClose, DialogFooter } from "@/components/ui/dialog"

  import successCheck from "@/assets/images/success-check.svg"

  const emit = defineEmits<{ switchCancelled: [] }>()

  const handleClose = () => emit("switchCancelled")
</script>
<template>
  <div class="overflow-y-auto" data-testid="switch-cancelled-confirmation">
    <div class="flex flex-col items-center text-secondary-500">
      <img :src="successCheck" alt="Success Check" class="mb-2" />
      <h3 class="my-4 text-center text-secondary-700">
        Your switch has now been cancelled
      </h3>
      <div class="my-4 text-center" data-testid="default-slot">
        In case we can help you in the future, why not sign up for updates on
        new ways to save energy, our competitive new tariffs and exciting new
        green solutions such as electric vehicles and solar panels?
      </div>
    </div>
    <DialogFooter class="sm:justify-center">
      <DialogClose as-child>
        <Button variant="outline" @click="handleClose">Account home</Button>
      </DialogClose>
      <DialogClose as-child>
        <Button type="submit" variant="primary" @click="handleClose">
          Keep me updated
        </Button>
      </DialogClose>
    </DialogFooter>
  </div>
</template>
